import styled from "styled-components";
export const GapContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const PaddingContainer = styled.div`
  padding: 1rem;
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #B8C4E0;
  padding: 0.25rem 0;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

export const InfoText = styled.p`
  margin: 0;
`;

export const WideFormWrapper = styled.div`
  & > div > div:last-child {
    min-width: 480px;
    width: max-content;
    flex-shrink: 0;
  }
`;

export const CreditDecisionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 28px;
  gap: 4px;
  color: #2B2B2B;
`;

export const CreditDecisionLabel = styled.label`
  font-weight: 600;
`;

export const CreditDecisionBox = styled.div`
  border: 1px solid #B8C4E0;
  border-radius: 5px;
  font-size: 14px;
  background-color: #fafafa;
  overflow: hidden;
`;

export const CreditDecisionStatus = styled.div<{ $hasBorder?: boolean }>`
  padding: 8px 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: ${({ $hasBorder }) => ($hasBorder ? "1px solid #B8C4E0" : "none")};
`;

export const CreditDecisionSpinner = styled.span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid #B8C4E0;
  border-top-color: #3B82F6;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export const UpdatedOfferSection = styled.div`
  padding: 8px 12px;
`;

export const UpdatedOfferLabel = styled.p`
  margin: 0;
  font-weight: 500;
  margin-bottom: 4px;
`;
